import type { CollectionMerchandising } from '@library/menu-service'
import type {
  GradientInfoHeaderMerchandising,
  WaveLinkHeaderMerchandising,
} from '@library/menu-service/internal/types'

import type { MenuHeadersIncludesData } from 'routes/Menu/domains/brand/types'

type SupportedOldHeader = WaveLinkHeaderMerchandising | GradientInfoHeaderMerchandising

const isSupportedOldHeader = (
  merchandising: CollectionMerchandising,
): merchandising is SupportedOldHeader =>
  merchandising.type === 'gradient-info-header' || merchandising.type === 'wave-link-header'

const mapGradientInfoHeader = (
  merchandising: GradientInfoHeaderMerchandising,
): MenuHeadersIncludesData => ({
  id: merchandising.type,
  type: merchandising.type,
  attributes: {
    gradientColor: merchandising.gradientColor,
    color: merchandising.color,
    headerImage: merchandising.headerImage,
    image: merchandising.image,
    description: merchandising.description,
  },
})

const mapWaveLinkHeader = (
  merchandising: WaveLinkHeaderMerchandising,
): MenuHeadersIncludesData => ({
  id: merchandising.type,
  type: merchandising.type,
  attributes: {
    backgroundColor: merchandising.backgroundColor,
    color: merchandising.color,
    headerImage: merchandising.headerImage,
    description: merchandising.description,
    link: {
      collectionId: merchandising.collectionId,
      collectionSlug: merchandising.collectionSlug ?? '',
    },
  },
})

export const getOldCollectionMerchandisingHeader = (
  merchandising?: CollectionMerchandising[] | null,
): MenuHeadersIncludesData | null => {
  const supportedHeader = merchandising?.find(isSupportedOldHeader)

  if (!supportedHeader) {
    return null
  }

  if (supportedHeader.type === 'gradient-info-header') {
    return mapGradientInfoHeader(supportedHeader)
  }

  return mapWaveLinkHeader(supportedHeader)
}
